<template>
  <g>
    <polygon points="0,2 45,4 70,4 70,0 75,0 75,16 70,16 70,12 45,12 0,14" fill="white" stroke="#ababab" stroke-width=".5" />
  </g>
</template>

<script>
export default {

}
</script>

<style>

</style>
